export default function registerGlobalVueFilters(Vue) {

    Vue.filter('formatDistance', function (value) {
        if (!value) return '';

        let number = parseFloat(value);
        if (isNaN(number)) return '';

        number = Math.round(number);

        if (number >= 1000) {
            return (number / 1000).toFixed(1) + ' km';
        } else {
            return number + ' m';
        }
    });

}